// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-header {
  background-color: #1498D5;
  color: #fff;
  padding: 3rem 1rem;
  text-align: center;
}

.about-header h1 {
  font-size: 2.5rem;
  font-weight: 600;
}

.about-container {
  background-color: #fff;
  padding: 2rem;
  margin-top: -2rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.about-container h5 {
  color: #1498D5;
  margin-top: 2rem;
  font-weight: 600;
}

.about-container p {
  line-height: 1.7;
}

@media (max-width: 576px) {
  .about-header h1 {
    font-size: 1.8rem;
  }
}
.category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.tag {
  background-color: #1498D5;
  color: white;
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 500;
}

.social-links a {
  margin-right: 1rem;
  color: --primary;
  font-weight: 500;
  text-decoration: none;
}

.social-links a:hover {
  text-decoration: underline;
}

@media (max-width: 576px) {
  h2 {
    font-size: 1.75rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/our-story/our-story.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,wCAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI;IACI,iBAAA;EACN;AACF;AAEA;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,0BAAA;AAAJ;;AAGA;EACI;IACI,6BAAA;EAAN;AACF","sourcesContent":[".about-header {\n    background-color: #1498D5;\n    color: #fff;\n    padding: 3rem 1rem;\n    text-align: center;\n}\n\n.about-header h1 {\n    font-size: 2.5rem;\n    font-weight: 600;\n}\n\n.about-container {\n    background-color: #fff;\n    padding: 2rem;\n    margin-top: -2rem;\n    border-radius: 0.5rem;\n    box-shadow: 0 0 10px rgba(0,0,0,0.05);\n}\n\n.about-container h5 {\n    color: #1498D5;\n    margin-top: 2rem;\n    font-weight: 600;\n}\n\n.about-container p {\n    line-height: 1.7;\n}\n\n@media (max-width: 576px) {\n    .about-header h1 {\n        font-size: 1.8rem;\n    }\n}\n\n.category-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n}\n\n.tag {\n    background-color: #1498D5;\n    color: white;\n    padding: 0.4rem 0.9rem;\n    border-radius: 999px;\n    font-size: 0.85rem;\n    font-weight: 500;\n}\n\n.social-links a {\n    margin-right: 1rem;\n    color: (--primary);\n    font-weight: 500;\n    text-decoration: none;\n}\n\n.social-links a:hover {\n    text-decoration: underline;\n}\n\n@media (max-width: 576px) {\n    h2 {\n        font-size: 1.75rem !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
